import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IhmPipesModule } from '../../shared/pipes/ihm-pipes.module';
import { IhmSelectAllCheckboxModule } from '../ihm-select-all-checkbox/ihm-select-all-checkbox.module';
import { IhmFilterableSelectComponent } from './ihm-filterable-select.component';

@NgModule({
  imports: [
    MatSelectModule,
    MatTooltipModule,
    ReactiveFormsModule,
    CommonModule,
    IhmSelectAllCheckboxModule,
    IhmPipesModule,
    MatInputModule,
    MatIconModule
  ],
  declarations: [IhmFilterableSelectComponent],
  exports: [IhmFilterableSelectComponent]
})
export class IhmFilterableSelectModule {}
